import {QueryDocumentSnapshot} from 'firebase/firestore';
import {FirestoreCursorStore} from '../../types/FirestoreCursorStore';

/**
 * Builds a FirestoreCursorStore from an array of QueryDocumentSnapshot
 * - first page: endBefore is undefined, startAfter is the first item
 * - last page: endBefore is the last item, startAfter is undefined
 * - middle pages: endBefore is the item before the current page, startAfter is the first item of the current page
 * @param data array of QueryDocumentSnapshot
 * @param pageIndex 0-based current page index
 * @param pageLimit number of items per page
 * @param totalCount total number of items
 * @returns FirestoreCursorStore
 */
export default function buildFirestoreCursorStore(
  data: QueryDocumentSnapshot<unknown>[],
  pageIndex: number,
  pageLimit: number,
  totalCount?: number,
): FirestoreCursorStore {
  const first: QueryDocumentSnapshot<unknown> | undefined = data[0];
  const last: QueryDocumentSnapshot<unknown> | undefined = data[pageLimit - 1];

  if (pageIndex === 0) {
    return {
      /** for first page, 'first' should be undefined */
      first: undefined,
      last,
    };
  }

  if (totalCount) {
    // total count is known, work out the last page
    const lastPage = Math.ceil(totalCount / pageLimit);
    if (pageIndex >= lastPage) {
      return {
        first,
        /** for last page, 'last' should be undefined */
        last: undefined,
      };
    }
  }
  return {
    first,
    last,
  };
}
